import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { PatientLetter } from '../models/patient-letter';

@Injectable({
  providedIn: 'root',
})
export class PatientLettersService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientLetters`;

  getPatientLetters(patientId: number): Observable<PatientLetter[]> {
    const url = `${this.endpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientLetter[]>(url);
  }

  getPatientLetter(patientLetterId: number, patientId: number): Observable<PatientLetter> {
    // API requires patientPortalUserId query param on detail endpoints.
    const url = `${this.endpoint}/${patientLetterId}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientLetter>(url);
  }

  postPrintEvent(patientId: number, patientLetterId: number): Observable<void> {
    const url = `${this.endpoint}/${patientLetterId}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, null, { skipGlobalError: true });
  }
}
